module.exports = __webpack_public_path__ + "static/media/question.4656abc1.svg";